
import { CategoryColor } from './CategoryColor'

export class ThemeUtils {

  static setTagStyleColor(classname, color) {
    var elements = document.getElementsByTagName(classname);
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.color = color;
    };
  }

  static setClassFilter(classname, filter) {
    var elements = document.getElementsByClassName(classname);
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.filter = filter;
    };
  }

  static setClassStyleColor(classname, color) {
    var elements = document.getElementsByClassName(classname);
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.color = color;
    };
  }

  static setClassStylePropColor(classname, property, color) {
    var elements = document.getElementsByClassName(classname);
    for (var i = 0; i < elements.length; i++) {
      elements[i].style[property] = color;
    };
  }

  static setClassStyleBgColor(classname, color) {
    var elements = document.getElementsByClassName(classname);
    for (var i = 0; i < elements.length; i++) {
      elements[i].style.background = color;
    };
  }

  static get_font_color() {
    let color_mode;

    if (localStorage.getItem("font_color_mode") === null) {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        color_mode = "dark";
      } else {
        color_mode = "";
      }
    } else {
      color_mode = localStorage.getItem('font_color_mode') !== null ? localStorage.getItem('font_color_mode') : "";
    }

    return color_mode;
  }

  static set_font_color(components_name_md5) {
    var current_font_size = parseInt(localStorage.getItem('font_size'));
    //console.log('fontsize '+current_font_size);
    if (window.document.getElementsByClassName("entry-content") && window.document.getElementsByClassName("entry-content")[0]){
      window.document.getElementsByClassName("entry-content")[0].style.fontSize = (current_font_size / 100) + "em";
    }
    if (window.document.getElementById("div_fontsize_text" + components_name_md5))
      window.document.getElementById("div_fontsize_text" + components_name_md5).innerHTML = current_font_size + "%";

    var color_mode = "";
    // DARK MODE DEACTIVATION
    // if (localStorage.getItem("font_color_mode") === null) {
    //   //Se non è impostato dall'utente imposto il dark mod in base
    //   //al tema del computer/smartphone, solo su safari
    //   if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //     color_mode = "dark";
    //     //localStorage.setItem("font_color_mode", "dark");
    //   } else {
    //     //localStorage.setItem("font_color_mode", "");
    //     color_mode = "";
    //   }
    // } else {
    //   color_mode = localStorage.getItem('font_color_mode') !== null ? localStorage.getItem('font_color_mode') : "";
    // }

    if (color_mode === "dark") {
      //DARK MODE
      //if (window.document.getElementsByTagName("BODY")[0].style.background === "#2f2f2f") return;
      //setClassStylePropColor("icon_prefered", "filter", "invert(1)");
      //window.document.getElementById("icon_share").style.filter = "invert(1)";
      //window.document.getElementById("prefered_share").style.filter = "invert(1)";
      //window.document.getElementById("font_share").style.filter = "invert(1)";
      window.document.getElementsByTagName("BODY")[0].style.background = "#0b0135";
      window.document.getElementsByTagName("BODY")[0].style.color = "white";

      this.setTagStyleColor("h1", "white");


      this.setClassStylePropColor("sponsored_div_img_desk", "filter", "invert(1)");
      this.setClassStylePropColor("byline", 'background', 'linear-gradient(180deg, rgba(46,46,46,1) 0%, rgba(46,46,46,1) 80%, rgba(46,46,46,0.8) 90%, rgba(46,46,46,0.3) 96%, rgba(46,46,46,0) 100%)');

      //console.log("set h2 color");
      this.setTagStyleColor("h2", "white");

      this.setClassStylePropColor("mag_announcement", "border", "2px solid #e7e7e74f");

      this.setClassStyleColor("mag_post_author", "#B2B4CA");
      this.setClassStyleColor("entry-author", "#B2B4CA");
      this.setClassStylePropColor("newmag_social_share", "filter", "invert(1)");
      // this.setClassStylePropColor("resp-sharing-button__icon", "filter", "invert(1)");

      this.setClassStylePropColor("cookie-privacy-item", "color", "white");
      this.setClassStylePropColor("author-card-name", "color", "white");
      this.setClassStylePropColor("saved-post-title", "color", "white");

      if (document.getElementById("reading_time"))
        document.getElementById("reading_time").style.color = "#2e2e2e";
      //document.getElementById("masthead").style.background = "#2e2e2e";
      if (document.getElementById("div_fontsize" + components_name_md5))
        document.getElementById("div_fontsize" + components_name_md5).style.background = "black";
      if (document.getElementById("div_shareeweb" + components_name_md5))
        document.getElementById("div_shareeweb" + components_name_md5).style.background = "black";
        this.setClassStylePropColor("white_mode", "filter", "invert(1)");
        this.setClassStylePropColor("dark_mode", "filter", "invert(1)");

        Object.keys(CategoryColor.array_colors).forEach(function (item) {
          if (document.getElementById("menu_desk_" + item))
          document.getElementById("menu_desk_" + item).style.color = "white";
      });
      document.querySelectorAll("img.icon_share.share_icons").forEach(img => {
        img.src='/img/share@2x_white.svg';
      });

      this.setClassStylePropColor('menu_group', 'color', '#white');
      this.setClassStylePropColor('menu_group', 'background', '#676767');
      this.setClassStylePropColor('mag_desktop_sidebar', 'border-right', '1px solid #676767');


      this.setClassFilter("newmag_agenda_icon_invert", "invert(0.82)");

      this.setClassStyleBgColor('theme-background-shadow', 'rgba(11, 1, 53, 1) 100%)');
      this.setClassStylePropColor('theme-background-shadow-gradient', 'background-image', `linear-gradient(
                rgba(11, 1, 53, 1, 0) 0%,
                rgba(11, 1, 53, 1, 0.2) 10%,
                rgba(11, 1, 53, 1, 0.4) 20%,
                rgba(11, 1, 53, 1, 0.6) 30%,
                rgba(11, 1, 53, 1) 100%)
              `);

    } else {
      //LIGHT MODE
      //localStorage.setItem('font_color_mode', "");
      //if (window.document.getElementsByTagName("BODY")[0].style.background === "white") return;
      //setClassStyleColor("icon_prefered", "filter", "invert(0)");
      //window.document.getElementById("icon_share").style.filter = "invert(0)";
      //window.document.getElementById("prefered_share").style.filter = "invert(0)";
      //window.document.getElementById("font_share").style.filter = "invert(0)";
      this.setClassStylePropColor("sponsored_div_img_desk", "filter", "none");

      window.document.getElementsByTagName("BODY")[0].style.background = "white";
      window.document.getElementsByTagName("BODY")[0].style.color = "#2e2e2e";
      this.setClassStylePropColor("byline", "background", "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 80%, rgba(255,255,255,0.8) 90%, rgba(255,255,255,0.3) 96%, rgba(255,255,255,0) 100%)");

      this.setTagStyleColor("h1", "");
      this.setTagStyleColor("h2", "");
      this.setClassStyleColor("mag_post_author", "");
      this.setClassStyleColor("entry-author", "");
      this.setClassStylePropColor("newmag_social_share", "filter", "invert(0)");
      this.setClassStylePropColor("mag_announcement", "border", "2px solid #E7E7E7");

      if (document.getElementById("reading_time"))
        document.getElementById("reading_time").style.color = "#2e2e2e";
      //document.getElementById("masthead").style.background = "#FFFFFF";
      if (document.getElementById("div_fontsize" + components_name_md5))
        document.getElementById("div_fontsize" + components_name_md5).style.background = "white";
      if (document.getElementById("div_shareeweb" + components_name_md5))
        document.getElementById("div_shareeweb" + components_name_md5).style.background = "white";

      this.setClassStylePropColor("white_mode", "filter", "invert(0)");
      this.setClassStylePropColor("dark_mode", "filter", "invert(0)");
      // this.setClassStylePropColor("resp-sharing-button__icon", "filter", "invert(0)");

      this.setClassStylePropColor("cookie-privacy-item", "color", "black");
      this.setClassStylePropColor("saved-post-title", "color", "black");

      Object.keys(CategoryColor.array_colors).forEach(function (item) {
        if (document.getElementById("menu_desk_" + item))
          document.getElementById("menu_desk_" + item).style.color = "#2e2e2e";
      });

      this.setClassStyleColor("menu_group", "black");
      this.setClassStyleBgColor("menu_group", "#F1F1F1");
      if (
        (window.document.getElementsByClassName("mag_desktop_sidebar")) &&
        (window.document.getElementsByClassName("mag_desktop_sidebar")[0])
      ) {
        window.document.getElementsByClassName("mag_desktop_sidebar")[0].style.borderRight = "1px solid #EDEDED";
      }

      this.setClassFilter("newmag_agenda_icon_invert", "");

      this.setClassStyleBgColor('theme-background-shadow', 'rgba(11, 1, 53, 1) 100%)');
      this.setClassStylePropColor('theme-background-shadow-gradient', 'background-image', `linear-gradient(
                rgba(11, 1, 53, 1, 0) 0%,
                rgba(11, 1, 53, 1, 0.2) 10%,
                rgba(11, 1, 53, 1, 0.4) 20%,
                rgba(11, 1, 53, 1, 0.6) 30%,
                rgba(11, 1, 53, 1) 100%)
              `);
      document.querySelectorAll("img.icon_share.share_icons").forEach(img => {
        img.src='/img/share_copy_3@2x.png';
      });

    }

  }

  static reset_theme (components_name_md5) {
    if (window.ga) {
        window.ga('send', {
        hitType: 'event',
        eventCategory: 'Option',
        eventAction: 'change theme',
        eventLabel: 'reset'
        });
    }

    localStorage.removeItem("font_color_mode");
    localStorage.setItem("font_size","100");
    document.getElementById('font_range').value = 100;

    //set_font_color(components_name_md5, "");
    document.getElementById("current_theme").innerHTML="auto";
    this.set_font_color(components_name_md5);
  }

  static dark_mode_toggle (components_name_md5) {
    this.dark_mode_toggle_exec (components_name_md5, "")
  }

  static dark_mode_toggle_exec (components_name_md5, mode) {

    if (window.ga) {
        window.ga('send', {
        hitType: 'event',
        eventCategory: 'Option',
        eventAction: 'change theme',
        eventLabel: mode
        });
    }


    //console.log(window.document.getElementsByTagName("BODY")[0].style.background);
    if (mode === "dark") {
        //DARK MODE
        localStorage.setItem('font_color_mode', "dark");

        this.set_font_color(components_name_md5);
        console.log('set dark mode');
    }
    else if (mode === "white") {
        //DARK MODE
        localStorage.setItem('font_color_mode', "");

        this.set_font_color(components_name_md5);
        console.log('set light mode');
    }
    else if (!mode && localStorage.getItem('font_color_mode') !== "dark") {
        //DARK MODE
        localStorage.setItem('font_color_mode', "dark");

        this.set_font_color(components_name_md5);
        console.log('set dark mode');
    }
    else {
        //LIGHT MODE
        localStorage.setItem('font_color_mode', "");

        this.set_font_color(components_name_md5);
        console.log('set light mode');
    }

    if (document.getElementById("current_theme"))
        document.getElementById("current_theme").innerHTML=localStorage.getItem('font_color_mode') === "dark"?"dark":"light";
  }
};
